import React, { useState, useEffect } from 'react'
import { Form, Icon } from 'semantic-ui-react'
import './DateInputCustom.css'

export default function DateInputCustom(props) {
  const [isOpen, setIsOpen] = useState(false)
  const [currentMonth, setCurrentMonth] = useState(new Date())
  const [selectedDate, setSelectedDate] = useState(props.value)

  // Generar opciones de años
  const generateYears = () => {
    const currentYear = new Date().getFullYear()
    const years = []
    for (let i = currentYear - 10; i <= currentYear + 5; i++) {
      years.push(i)
    }
    return years
  }

  // Generar opciones de meses
  const generateMonths = () => {
    return [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ]
  }

  // Generar días del mes
  const generateDays = () => {
    const year = currentMonth.getFullYear()
    const month = currentMonth.getMonth()
    const firstDay = new Date(year, month, 1)
    const lastDay = new Date(year, month + 1, 0)
    const daysInMonth = lastDay.getDate()
    const startingDayOfWeek = firstDay.getDay()

    const days = []

    // Días del mes anterior
    const prevMonth = new Date(year, month - 1, 0)
    for (let i = startingDayOfWeek - 1; i >= 0; i--) {
      days.push({
        day: prevMonth.getDate() - i,
        isCurrentMonth: false,
        isSelected: false
      })
    }

    // Días del mes actual
    for (let day = 1; day <= daysInMonth; day++) {
      const isSelected = selectedDate &&
        selectedDate.getDate() === day &&
        selectedDate.getMonth() === month &&
        selectedDate.getFullYear() === year

      days.push({
        day,
        isCurrentMonth: true,
        isSelected
      })
    }

    // Días del mes siguiente para completar la grilla
    const remainingDays = 42 - days.length
    for (let day = 1; day <= remainingDays; day++) {
      days.push({
        day,
        isCurrentMonth: false,
        isSelected: false
      })
    }

    return days
  }

  // Manejar selección de día
  const handleDayClick = (day, isCurrentMonth) => {
    if (isCurrentMonth) {
      const newDate = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day)
      setSelectedDate(newDate)
      props.onChange(newDate)
      setIsOpen(false)
    }
  }

  // Manejar cambio de mes
  const handleMonthChange = (monthIndex) => {
    const newMonth = new Date(currentMonth.getFullYear(), monthIndex, 1)
    setCurrentMonth(newMonth)
  }

  // Manejar cambio de año
  const handleYearChange = (year) => {
    const newMonth = new Date(year, currentMonth.getMonth(), 1)
    setCurrentMonth(newMonth)
  }

  // Navegación de mes
  const navigateMonth = (direction) => {
    const newMonth = new Date(currentMonth)
    newMonth.setMonth(currentMonth.getMonth() + direction)
    setCurrentMonth(newMonth)
  }

  // Formatear fecha para mostrar
  const formatDate = (date) => {
    if (!date) return ''
    return date.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    })
  }

  // Actualizar cuando cambie el valor
  useEffect(() => {
    if (props.value) {
      setSelectedDate(props.value)
      setCurrentMonth(props.value)
    }
  }, [props.value])

  const months = generateMonths()
  const years = generateYears()
  const days = generateDays()
  const dayNames = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']

  return (
    <Form.Field error={props.error} required={props.required}>
      <label>{props.icon && <Icon name={props.icon} />} {props.label}</label>

      <div className="custom-date-input">
        <input
          type="text"
          placeholder={props.placeholder || props.label}
          value={formatDate(selectedDate)}
          readOnly
          onClick={() => setIsOpen(!isOpen)}
          className="date-input-field"
        />

        {isOpen && (
          <div className="custom-calendar">
            {/* Encabezado con navegación y selectores */}
            <div className="calendar-header">
              <button
                className="nav-button"
                onClick={() => navigateMonth(-1)}
              >
                ‹
              </button>

              <div className="month-year-selector">
                <select
                  value={currentMonth.getMonth()}
                  onChange={(e) => handleMonthChange(parseInt(e.target.value))}
                  className="month-select"
                >
                  {months.map((month, index) => (
                    <option key={index} value={index}>{month}</option>
                  ))}
                </select>

                <select
                  value={currentMonth.getFullYear()}
                  onChange={(e) => handleYearChange(parseInt(e.target.value))}
                  className="year-select"
                >
                  {years.map(year => (
                    <option key={year} value={year}>{year}</option>
                  ))}
                </select>
              </div>

              <button
                className="nav-button"
                onClick={() => navigateMonth(1)}
              >
                ›
              </button>
            </div>

            {/* Días de la semana */}
            <div className="day-names">
              {dayNames.map(day => (
                <div key={day} className="day-name">{day}</div>
              ))}
            </div>

            {/* Grilla de días */}
            <div className="days-grid">
              {days.map((dayObj, index) => (
                <div
                  key={index}
                  className={`day-cell ${dayObj.isCurrentMonth ? 'current-month' : 'other-month'} ${dayObj.isSelected ? 'selected' : ''}`}
                  onClick={() => handleDayClick(dayObj.day, dayObj.isCurrentMonth)}
                >
                  {dayObj.day}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </Form.Field>
  )
}

DateInputCustom.defaultProps = {
  label: 'Fecha',
  placeholder: null,
  disabled: false,
  loading: false,
  transparent: false,
  error: false,
  value: null,
  onChange: () => { },
}
